<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
import PaymentsTableTab from '@/components/payments/PaymentsTableTab.vue';
import type { PaymentsTabId } from '@/composables/usePayments';
import {
    NON_CLEARED_STATUSES,
    PENDING_ONLY_STATUSES,
} from '@/services/paymentStatus';

defineProps<{
    tabId?: PaymentsTabId;
}>();
</script>

<template>
    <!-- PHASE 2: UNCOMMENT THIS WHEN PHASE 2 STARTS — restore action-mode="reject". -->
    <PaymentsTableTab
        :base-statuses="NON_CLEARED_STATUSES"
        :default-statuses="PENDING_ONLY_STATUSES"
        :status-options="NON_CLEARED_STATUSES"
        empty-description="No pending payments match your current filters."
        process-date-mode="process-date"
        action-mode="none"
    />
</template>
